// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!../../node_modules/@fontsource/noto-sans-jp/400.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!../../node_modules/@fontsource/noto-sans-jp/700.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fourier-film {
  font-family: "Noto Sans JP", sans-serif;
  -webkit-font-smoothing: antialiased;
}
`, "",{"version":3,"sources":["webpack://./src/fourier/style.css"],"names":[],"mappings":"AAGA;EACE,uCAAuC;EACvC,mCAAmC;AACrC","sourcesContent":["@import \"@fontsource/noto-sans-jp/400.css\";\n@import \"@fontsource/noto-sans-jp/700.css\";\n\n.fourier-film {\n  font-family: \"Noto Sans JP\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
